export default __webpack_public_path__ + "static/media/right.63ae483901d27cc2957893f1cd4af660.svg";